import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { ThemeSelectors, TypeMini } from '@at/design-system-foundation';
export var SpecificationList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    padding: 0 ", ";\n    list-style: none;\n    margin: 0 0 ", ";\n    gap: ", ";\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    padding: 0 ", ";\n    list-style: none;\n    margin: 0 0 ", ";\n    gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupThreeSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
});
export var SpecificationItem = styled(TypeMini)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-basis: calc((100% - ", ") / 2);\n    white-space: nowrap;\n    gap: ", ";\n    align-items: center;\n"], ["\n    display: flex;\n    flex-basis: calc((100% - ", ") / 2);\n    white-space: nowrap;\n    gap: ", ";\n    align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupTwoSpacing(theme);
});
var templateObject_1, templateObject_2;
